module.exports = __webpack_public_path__ + "img/icn_brand11.379b53db.svg";